import type { ExpressionSpecification } from "maplibre-gl";

export const IS_POLYGON: ExpressionSpecification = ["==", ["geometry-type"], "Polygon"];
export const IS_LINE: ExpressionSpecification = ["==", ["geometry-type"], "LineString"];
export const IS_POINT: ExpressionSpecification = ["==", ["geometry-type"], "Point"];

export const LAND_COLOR = "#ffffff";

export const WETLAND_COLOR = "#2f8f6b";
export const WETLAND_OUTLINE_COLOR = "#1b6349";

export const HOVER_COLOR = "#14513c";
export const SELECTION_COLOR = "#e07b1f";

export const WATER_FILL_COLOR = "#c3d9e8";
export const WATER_LINE_COLOR = "#8fb4cc";
export const WATER_LABEL_COLOR = "#4a80a3";

export const ROAD_COLOR = "#e2ded7";

export const PARK_FILL_COLOR = "#e4efdd";
export const PARK_LINE_COLOR = "#b6ceaa";
export const PARK_LABEL_COLOR = "#4a6b52";

export const BOUNDARY_COLOR = "rgba(70, 80, 90, 0.35)";
export const BOUNDARY_MARITIME_COLOR = "rgba(122, 153, 174, 0.35)";

export const LABEL_COLOR = "#2c3a34";
export const LABEL_SECONDARY_COLOR = "#5c6a63";
export const LABEL_HALO_COLOR = "rgba(255, 255, 255, 0.9)";

export const FONT_REGULAR = ["Noto Sans Regular"];
export const FONT_BOLD = ["Noto Sans Bold"];
